<template>
  <div :class="{
    'avatar-online': showOnline,
    'profile-avatar': profile,
    'chat-avatar': chat,
    'avatar': !profile && !chat,
  }">

    <img
      v-if="src ? src : user.profile?.profile_picture_url"
      :src="src ? src : user.profile?.profile_picture_url"
      :class="{
        'shadow-lg': profile,
        'rounded-circle avatar_chat position-relative': chat,
      }"
      class="rounded-circle"
      :alt="alt"
    />

    <div v-else class="no-avatar">{{initials}}</div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    src: {
      type: [String, null],
      required: false,
    },

    alt: {
      type: String,
      default: 'User avatar',
    },

    user: {
      type: Object,
      required: true,
    },

    online: {
      type: Boolean,
      default: false,
    },

    profile: {
      type: Boolean,
      default: false,
    },

    chat: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      activeUsers: 'chat/activeUsers',
    }),

    initials() {
      if (this.user.profile?.display_name) {
        return this.user.profile?.display_name[0].toUpperCase();
      }

      return 'U';
    },

    showOnline() {
      return this.user.id && this.online && this.activeUsers.includes(this.user.id);
    },
  },

  data() {
    return {

    };
  },

  created() {
    //
  },

  methods: {
    //
  },
};
</script>

<style scoped>
.no-avatar {
  width: 100%;
  height: 100%;
  background: #e6e6e6;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #dc1253;
}

.profile-avatar {
  display: flex;
  justify-content: center;
}

.profile-avatar .no-avatar {
  width: 160px;
  height: 160px;
  font-size: 40px;
}
</style>
